module.exports = __webpack_public_path__ + "static/media/taizhangguanli.94b80392.png";